import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

//Components
import FormCredenciamento from '../../../../containers/forms/credenciamento/FormCredenciamento';
import Body from '../../../../components/layoutcredenciamento/Body';
import Header from '../../../../components/layoutcredenciamento/Header';
import Footer from '../../../../components/layoutcredenciamento/Footer';
import Layout from '../../../../components/layoutcredenciamento/Layout';

//Utils
import { getEvento, getCategoriaCred, getLinguagemCred, getUserLoginCred } from '../../../../utils/eventosessioncred';

const Cadastro  = (props) => {
    
    const evento = getEvento();
    const user = getUserLoginCred();
    const [categoria, getCategoria] = useState(getCategoriaCred());
    const [linguagem, getLinguagem] = useState(getLinguagemCred());
    
    return (
        <Layout>
            <Header categoriafixada={true} getCategoria={getCategoria} getLinguagem={getLinguagem}  pagina="cadastro" prelogin={false} />
            <Body>
                <FormCredenciamento 
                somenteperguntas={props.somenteperguntas}
                handleNovoCad={() => props.history.push('login')}
                dadosevento={{
                    idevento: evento.idevento,
                    idpromotora: evento.idpromotora,
                    categoria: categoria,
                    lingua: linguagem
                }}
                dadoscadastro={{
                    idfisica: user&&user.idfisica?user.idfisica:0
                }}
                btosair={{
                    url: '',
                    texto: 'SAIR'
                }}
                />
            </Body>
            <Footer />
        </Layout>
    )    
}

const mapStateToProps = (state) => {
    return {
        getCredencial: state.getCredencialReducer
    }
}

export default connect(mapStateToProps)(withRouter(Cadastro));